/* global __DEV__ */

export default (msg, ...optionalParams) => {
  if (__DEV__) {
    console.log(new Date(), msg, ...optionalParams);
  }
};
